module.exports = __webpack_public_path__ + "assets/img/eski-con-gavoni.47150d76.png";